import React, { useState, useEffect } from 'react';
import './FallingHearts.css';

const FallingHearts = ({ numHearts = 10, duration = 3 }) => {
  const [hearts, setHearts] = useState([]);

  useEffect(() => {
    const interval = setInterval(() => {
      setHearts((prev) => [
        ...prev,
        { id: Math.random(), left: Math.random() * 100 }
      ]);

      if (hearts.length > numHearts) {
        setHearts((prev) => prev.slice(1));
      }
    }, duration * 300);

    return () => clearInterval(interval);
  }, [hearts.length, numHearts, duration]);

  return (
    <div className="falling-hearts-overlay">
      {hearts.map((heart) => (
        <div
          key={heart.id}
          className="heart"
          style={{
            left: `${heart.left}%`,
            animationDuration: `${duration}s`,
          }}
        >
          ❤️
        </div>
      ))}
    </div>
  );
};

export default FallingHearts;
